import { Box, Paper, Typography } from "@mui/material";
import type { ReactNode } from "react";

import { CRM_COLORS } from "../../lib/crm";

type CrmCardProps = {
  title?: ReactNode;
  icon?: ReactNode;
  actions?: ReactNode;
  footer?: ReactNode;
  children: ReactNode;
  // Cards without padding hold tables that reach the card edge.
  flush?: boolean;
  testId?: string;
};

export const CrmCard = ({ title, icon, actions, footer, children, flush = false, testId }: CrmCardProps) => (
  <Paper
    elevation={0}
    data-testid={testId}
    sx={{
      backgroundColor: CRM_COLORS.cardBackground,
      border: `1px solid ${CRM_COLORS.cardBorder}`,
      borderRadius: "4px",
      boxShadow: CRM_COLORS.cardShadow,
      overflow: "hidden",
    }}
  >
    {(title || actions) && (
      <Box sx={{ display: "flex", alignItems: "center", gap: "12px", px: "16px", pt: "12px", pb: flush ? "12px" : 0 }}>
        {icon}
        <Typography
          component="h2"
          sx={{ flex: 1, minWidth: 0, fontSize: "14px", fontWeight: 700, color: CRM_COLORS.text }}
        >
          {title}
        </Typography>
        {actions}
      </Box>
    )}
    <Box sx={flush ? undefined : { p: "12px 16px 16px" }}>{children}</Box>
    {footer && (
      <Box sx={{ borderTop: `1px solid ${CRM_COLORS.cardBorder}`, py: "10px", textAlign: "center", fontSize: "13px" }}>
        {footer}
      </Box>
    )}
  </Paper>
);
